import { Button } from "@/components/ui/button";
import { useHelp } from "@/lib/help.ts";
import { StarRow } from "./StarRow.tsx";

export interface WelcomeCopy {
  eyebrow: string;
  title: string;
  blurb: string;
}

const DAILY: WelcomeCopy = {
  eyebrow: "Today's puzzle",
  title: "Where in the Bible does this live?",
  blurb: "Sounds hard? Don't worry — you'll be walked down from the testament to the very verse, and you'll be helped along the way.",
};

export function Welcome({ onBegin, previousStars, copy = DAILY }: { onBegin: () => void; previousStars?: number; copy?: WelcomeCopy }) {
  return (
    <section className="animate-leaf-in flex flex-col items-center gap-5 py-10 text-center" style={{ ["--d" as string]: "200ms" }}>
      <p className="font-ui text-[0.7rem] font-semibold uppercase tracking-[0.24em] text-brand">{copy.eyebrow}</p>
      <h1 className="max-w-md font-display text-5xl italic leading-[1.02] sm:text-6xl">{copy.title}</h1>
      <p className="max-w-md font-body text-[1.08rem] italic text-muted-foreground">{copy.blurb}</p>
      {previousStars !== undefined && (
        <div className="flex flex-col items-center gap-1 font-ui text-xs text-muted-foreground">
          You've solved this one before
          <StarRow count={previousStars} size="text-2xl" />
        </div>
      )}
      <Button size="lg" onClick={onBegin} className="mt-2 h-12 px-8 text-base font-ui">
        Begin
      </Button>
      <button type="button" onClick={() => useHelp.getState().show("how")} className="font-ui text-sm text-muted-foreground underline underline-offset-4 hover:text-foreground">
        How does it work?
      </button>
    </section>
  );
}
